<div id="scrollBody" class="scroll-body ">
    <a class="avs-nav-button me-2  mt-2" routerLinkActive="active" routerLink="../schema"
        mat-raised-button>Aufnahmen</a>
    <div class="card rounded-0 mt-3 shadow p-2">
        <p class="fw-semibold text-secondary"> Verkehrsüberwachungs-Einstellungen</p>

        <span class="fw-semibold">Hinweis:</span> Abhängigkeit zu Browsereinstellungen - unter Umständen könnte ihr
        Browser dafür
        sorgen,
        dass der Alarm nicht abgespielt werden kann.

    </div>


    <div *ngIf="activeGroup; else noActiveProject" class="m-0">

        <div class="card rounded-0 shadow mt-4 p-2">
            <div class="fw-semibold d-flex justify-content-between">
                <div class="fw-semibold">Verkehrsüberwachung: <span class="text-danger">{{activeGroup.name}} </span>
                    <span class="text-danger" *ngIf="!activeGroup.isActive">- Gruppe ist deaktiviert </span>
                </div>
            </div>
            <div class="d-flex ">
                <div class="border border-1 w-50">
                    <!--                     <h2>Kamera (KFZ)</h2>
 -->
                    <div *ngIf="lpRecordings.length > 0; else noLPStations">
                        <div *ngFor="let station of lpRecordings; let i = index"
                            [ngClass]="(lpRecordings.length > 1 && i !== lpRecordings.length - 1)? 'cam-divider' : ''">
                            <div *ngIf="station.schemaInfo?.online">
                                <p class="fw-semibold">Station: {{ station.routeStation.name }}</p>
                                <p>Anzahl: {{ station.recordings.length }}</p>
                            </div>
                            <div *ngIf="!station.schemaInfo?.online">
                                <p>Station offline</p>
                            </div>

                            <div>Aufnahmen {{ station?.schemaInfo?.cameras?.[0]?.camType === 18 ? "Kennzeichenkamera" :
                                "Überwachungskamera" }}:</div>
                            <div class="d-flex align-items-center gap-2">
                                <mat-form-field>
                                    <mat-label> Aufnahme</mat-label>
                                    <mat-select [(ngModel)]="station.selectedRecording"
                                        [compareWith]="compareRecordings"
                                        (ngModelChange)="onDomeRecordingChange($event, station)">
                                        <mat-option *ngFor="let rec of lpRecordings[i].recordings" [value]="rec"
                                            [ngClass]="rec.endTime === null ? 'text-danger fw-semibold' : ''">
                                            {{ rec.startTime | date:'dd.MM.yyyy HH:mm:ss' }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button *ngIf="isCurrentUserAllowedToDownload"
                                    [disabled]="station.selectedRecording === undefined" mat-flat-button color="primary"
                                    (click)="downloadLPVideo(station)">Download
                                    Video</button>

                            </div>
                            <p> Ausgewählter Zeitraum:
                                {{station.selectedRecording?.startTime | date:'dd.MM.yyyy HH:mm:ss'}}
                                - {{station.selectedRecording?.endTime | date:'dd.MM.yyyy HH:mm:ss'}} </p>

                            <avs-axis-rtsp-player [rs]="station.routeStation.id" [token]="auth.getJwtToken()"
                                [selectedRecording]="station.selectedRecording"></avs-axis-rtsp-player>
                        </div>
                    </div>
                    <ng-template #noLPStations>
                        <mat-spinner *ngIf="isLpLoading" diameter="96"></mat-spinner>
                        <p *ngIf="!isLpLoading" class="mt-3 fw-semibold text-secondary">{{displayMessage}}</p>




                    </ng-template>
                </div>



                <div class="border border-1 w-50">
                    <!--                     <h2>Kamera (PTZ)</h2>
 -->
                    <div *ngIf="domeRecordings.length > 0; else noDomeStations">
                        <div *ngFor="let station of domeRecordings ; let i = index"
                            [ngClass]="(domeRecordings.length > 1 && i !== domeRecordings.length - 1)? 'cam-divider' : ''">
                            <div *ngIf="station.schemaInfo?.online">
                                <p class="fw-semibold">Station: {{ station.routeStation.name }}</p>
                                <p>Anzahl: {{ station.recordings.length }}</p>
                            </div>
                            <div *ngIf="!station.schemaInfo?.online">
                                <p>Station offline</p>
                            </div>
                            <div>Aufnahmen {{ station?.schemaInfo?.cameras?.[0]?.camType === 18 ? "Kennzeichenkamera" :
                                "Überwachungskamera" }}:</div>
                            <div class="d-flex align-items-center gap-2">
                                <mat-form-field>
                                    <mat-label> Aufnahme</mat-label>
                                    <mat-select [(ngModel)]="station.selectedRecording"
                                        (ngModelChange)="onDomeRecordingChange($event, station)"
                                        [compareWith]="compareRecordings">
                                        <mat-option *ngFor="let rec of station.recordings" [value]="rec">
                                            {{ rec.startTime | date:'dd.MM.yyyy HH:mm:ss' }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button *ngIf="isCurrentUserAllowedToDownload"
                                    [disabled]="station.selectedRecording === undefined" mat-flat-button color="primary"
                                    (click)="downloadVideo(i, station)">Download
                                    Video</button>
                            </div>
                            <p> Ausgewählter Zeitraum:
                                {{station.selectedRecording?.startTime | date:'dd.MM.yyyy HH:mm:ss'}}
                                - {{station.selectedRecording?.endTime | date:'dd.MM.yyyy HH:mm:ss'}} </p>

                            <avs-axis-rtsp-player [rs]="station.routeStation.id" [token]="auth.getJwtToken()"
                                [selectedRecording]="station.selectedRecording"></avs-axis-rtsp-player>
                        </div>
                    </div>
                    <ng-template #noDomeStations>
                        <mat-spinner *ngIf="isDomeLoading" diameter="96"></mat-spinner>
                        <p *ngIf="!isDomeLoading" class="mt-3 fw-semibold text-secondary">{{displayMessage}}</p>


                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noActiveProject>
        <p class="mt-3 fw-semibold text-secondary">Keine Gruppe ausgewählt!</p>
    </ng-template>
</div>